/**
 * Import node modules.
 */
// npm install smoothscroll-polyfill --save
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

/**
 * Require other JS libraries.
 */
const WebFont = require('webfontloader');
const lazysizes = require('./libs/lazysizes-5.3.1.js');
const jpInView = require('./libs/jpInView.js');

const animation = require('./animation.js');

// add os name for os specific css
var OSName="Unknown OS";
if (navigator.appVersion.indexOf("Win")!=-1) OSName="windows";
if (navigator.appVersion.indexOf("Mac")!=-1) OSName="macOS";
if (navigator.appVersion.indexOf("X11")!=-1) OSName="unix";
if (navigator.appVersion.indexOf("Linux")!=-1) OSName="linux";

document.body.classList.add('browser-type--' + OSName);

/**
 * Components
 */

const carousels = require('./components/carousel.js');
const forms = require('./components/forms.js');
const header = require('./components/header.js');
const headings = require('./components/headings-wysiwyg.js');
const footer = require('./components/footer.js');
const tables = require('./components/tables.js');

/**
 * Blocks
 */

const accordion = require('./blocks/accordion.js');
const coreBlocks = require('./blocks/core-blocks.js');
const calculator = require('./blocks/calculator.js');
const slidesCarousel = require('./blocks/carousel-slides.js');
const dynamicTabs = require('./blocks/dynamic-tabs.js');
const heroPrimary = require('./blocks/hero-primary.js');
const heroSecondary = require('./blocks/hero-secondary.js');
const image = require("./blocks/image.js");
const mediaAndBlocks = require('./blocks/media-and-blocks.js');
const storyListing = require('./blocks/story-listing.js');
const tabsAndContent = require('./blocks/tabs-and-content.js');
const videoEmbed = require('./blocks/video.js');



/**
 * Templates
 */

const post = require('./templates/post.js');




// Use lazysizes to get lazy loading on css background images.
document.addEventListener('lazybeforeunveil', function (e) {
	try {
		var bg = e.target.getAttribute('data-bg');
        if (bg) {
    		e.target.style.backgroundImage = 'url(' + bg + ')';
        }

	} catch (error) {
		console.log('Error with lazyload background:');
		console.log(error);
	}

});
